import { useQuery } from '@tanstack/react-query'

import { connection as SOLANA_CONNECTION } from '@src/chains/solana/anchor/setup'
import { ChainId } from '@src/configs/chainInfo'
import { GasFeeMetrics } from '@src/types/gasFees'

export const getSolanaGasFeeMetrics = async () => {
    // Get a recent blockhash
    const latestBlockhash = await SOLANA_CONNECTION.getLatestBlockhash()

    // Solana fees are generally stable at ~5000 lamports per signature on mainnet.
    const feePerSignature = BigInt(5000)

    // Fetch minimum rent exemption for a typical account (e.g. a token account of 165 bytes)
    const minimumRentExemption = BigInt(await SOLANA_CONNECTION.getMinimumBalanceForRentExemption(165))

    const metrics: GasFeeMetrics = {
        chainId: ChainId.Solana,
        currentGasPrice: BigInt(0), // Not applicable for Solana
        isEIP1559: false,
        isTron: false,
        isSolana: true,
        SolanaParams: {
            feePerSignature,
            recentBlockhash: latestBlockhash.blockhash,
            minimumRentExemption,
        },
    }

    return metrics
}

export const useGasFeeMetricsSolana = () => {
    const {
        data: gasFeeMetrics,
        error,
        isLoading,
    } = useQuery({
        queryKey: ['solanaGasFeeMetrics', ChainId.Solana],
        queryFn: getSolanaGasFeeMetrics,
        staleTime: 60000, // 1 minute caching
        retry: 2,
    })

    return {
        gasFeeMetrics: gasFeeMetrics || null,
        error: error ? `Error fetching Solana gas metrics: ${(error as Error).message}` : null,
        isLoading,
    }
}
